import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore, collection, addDoc } from 'firebase/firestore'; // Adicionado collection e addDoc
import { getStorage } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyDpgrpuxuLXqM9HNwfd2j5NnLGiQBhu3M8",
  authDomain: "projetoteste-a81b5.firebaseapp.com",
  projectId: "projetoteste-a81b5",
  storageBucket: "projetoteste-a81b5.firebasestorage.app",
  messagingSenderId: "6409632539",
  appId: "1:6409632539:web:aafa8551ff79558b1531be",
  measurementId: "G-70V4971DLV"
};

export const googleProvider = new GoogleAuthProvider();

googleProvider.setCustomParameters({
  prompt: "select_account"
});

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// --- FUNÇÃO DE LOGS DE AUDITORIA ---
export const saveLog = async (userProfile, action, details) => {
  try {
    await addDoc(collection(db, "logs"), {
      adminId: userProfile?.uid || "system",
      adminName: userProfile?.name || userProfile?.displayName || "Admin",
      adminRole: userProfile?.userType || "admin",
      action: action,
      details: details,
      timestamp: new Date().toISOString(),
    });
  } catch (error) {
    console.error("Erro ao gerar log no Firebase:", error);
  }
};
// ------------------------------------

let analytics = null;
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app);
}

export { analytics };
export default app;